































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import dayjs from 'dayjs'
import {
    applyMerchants,
    CustomerApplyDto,
    getMerchantsGroupList, getMerchantsLevelList,
    GroupListDto,
    LevelListDto,
    TagListDto,
    EmployeeDto,
    DepDto, GetEmployeeList, GetOrganizationInfoAll
} from '@/api/customerManage'
import { Getter } from 'vuex-class'
import LabelFilters from '@/views/customerManage/template/LabelFilters.vue'
import GroupFilters from '@/views/customerManage/template/GroupFilters.vue'
import LevelFilters from '@/views/customerManage/template/LevelFilters.vue'
import TypeFilters from '@/views/customerManage/template/TypeFilters.vue'
import DatePickers from '@/components/DatePickers/index.vue'

@Component({
    name: 'AddCustomerNext',
    components: {LabelFilters, GroupFilters, LevelFilters, TypeFilters, DatePickers}
})
export default class AddCustomerNext extends Vue {
    @Getter companyId!: string
    labelWidth = '7em'
    showCalendar1 = false // 签约开始时间选择空间显示控制
    showCalendar2 = false // 签约结束时间选择空间显示控制
    formData: CustomerApplyDto = {
        applyMessage: '',
        merchantsRemark: '',
        isAllowBuy: true,
        merchantsCode: '',
        groupName: '',
        groupId: '',
        tagList: [],
        levelName: '',
        levelId: '',
        deptId: '',
        deptName: '',
        maintainId: '',
        maintainName: '',
        recommendId: '',
        recommendName: '',
        appointmentStart: '',
        appointmentEnd: '',
        remark: '',
        merchantsType: '',
        merchantsTypeName: ''
    }
    merchantsId = ''
    showDepPicker = false
    showMaintainPicker = false
    showRecommendPicker = false
    tagList: TagListDto[] = []
    levelList: LevelListDto[] = []
    groupList: GroupListDto[] = []
    depList: DepDto[] = []
    employeeList: EmployeeDto[] = [] // 员工列表
    recommendList: EmployeeDto[] = [] // 推荐人列表
    defaultDate = null
    showcomfirm = false

    get isshowcomfirm () {
        return this.showcomfirm
    }

    created () {
        this.$nextTick(() => {
            let query = this.$route.query
            this.merchantsId = query.merchantsId as string
            this.formData.merchantsCode = query.merchantsCode as string
            this.getLevelList()
            this.getGroupList()
            this.getRecommendList()
            this.getDepList()
            if (this.formData.appointmentStart && this.formData.appointmentEnd) {
                this.showcomfirm = true
            }
        })
    }

    validatorLevel (val: string) {
        if (this.formData.isAllowBuy) {
            return !!val
        } else {
            return true
        }
    }

    selectcheck (date) {
        const [start, end] = date
        if (start !== null && end !== null) {
            this.showcomfirm = true
        } else {
            this.showcomfirm = false
        }
    }

    // input输入限制（英文、数字）独立编码
    formatterInput (value) {
        return value.replace(/[^a-zA-Z\d]/g, '')// 英文和数字
    }

    /**
     * 获取级别列表
     */
    getLevelList () {
        getMerchantsLevelList({}).then((res) => {
            this.levelList = res.data.levelList || []
        })
    }

    /**
     * 获取分组列表
     */
    getGroupList () {
        getMerchantsGroupList({}).then((res) => {
            this.groupList = res.data.groupList || []
        })
    }

    /**
     * 获取部门列表
     */
    getDepList () {
        GetOrganizationInfoAll({}).then((res) => {
            this.depList = res.data
            this.depList.forEach(item => {
                if (item.isEnabled === '0' || item.orgType === '1') {
                    item.disabled = true
                }
            })
        })
    }

    /**
     * 获取相关负责人列表
     */
    getEmployeeList () {
        let params = {
            orgId: this.formData.deptId, // 部门编号
            isPage: 'false'
        }
        return new Promise<void>(resolve => {
            GetEmployeeList(params).then((res) => {
                this.employeeList = res.data || []
                this.employeeList.forEach(item => {
                    if (item.ISENABLED === 'false') {
                        item.disabled = true
                    }
                })
                resolve()
            })
        })
    }

    /**
     * 获取推荐人列表
     */
    getRecommendList () {
        let params = {
            isPage: 'false'
        }
        GetEmployeeList(params).then((res) => {
            this.recommendList = res.data || []
            this.recommendList.forEach(item => {
                if (item.ISENABLED === 'false') {
                    item.disabled = true
                }
            })
        })
    }

    depConfirm (value: DepDto) {
        this.formData.deptId = value.orgId
        this.formData.deptName = value.orgName
        this.formData.maintainId = ''
        this.formData.maintainName = ''
        this.showDepPicker = false
    }

    maintainConfirm (value: EmployeeDto) {
        this.formData.maintainId = value.EMPLOYEEID
        this.formData.maintainName = value.EMPLOYEENAME
        this.showMaintainPicker = false
    }

    recommendConfirm (value: EmployeeDto) {
        this.formData.recommendId = value.EMPLOYEEID
        this.formData.recommendName = value.EMPLOYEENAME
        this.showRecommendPicker = false
    }

    resetrecommend () {
        this.formData.recommendId = ''
        this.formData.recommendName = ''
        this.showRecommendPicker = false
    }

    addSure () {
        (this.$refs.creatCompany as any).validate().then(() => {
            let params = {
                ...this.formData,
                merchantsId: this.merchantsId
            }
            applyMerchants(params).then(() => {
                this.$toast.success({
                    message: '已发送申请',
                    duration: 1000,
                    onClose: () => {
                        this.$router.back()
                    }
                })
            })

        })
    }

    /**
     * 选择维护人员
     */
    async selectMaintain () {
        if (!this.formData.deptId) {
            return this.$toast('请先选择所属部门')
        }
        await this.getEmployeeList()
        this.showMaintainPicker = true
    }

    /**
     * 选择客户标签
     */
    selectTag () {
        const options: { companyId: string, tags: TagListDto[] } = {
                companyId: this.companyId,
                tags: JSON.parse(JSON.stringify(this.formData.tagList))
            }
        ;(this.$refs.labelFilters as any).show(options)
    }

    /**
     * 获取选择的客户标签
     * @param data
     */
    getTagId (data: TagListDto[]) {
        this.formData.tagList = data
    }

    /**
     * 显示客户分组
     */
    showGroup () {
        const options: { companyId: string, groupId: string } = {
                companyId: this.companyId,
                groupId: this.formData.groupId
            }
        ;(this.$refs.groupFilters as any).show(options)
    }

    /**
     * 显示客户级别
     */
    showLevel () {
        const options: { companyId: string, levelId: string } = {
                companyId: this.companyId,
                levelId: this.formData.levelId
            }
        ;(this.$refs.levelFilters as any).show(options)
    }

    /**
     * 显示客户类别
     */
    showType () {
        const options: { companyId: string, dataId: string } = {
                companyId: this.companyId,
                dataId: this.formData.merchantsType
            }
        ;(this.$refs.TypeFilters as any).show(options)
    }

    getGroupId (id: string, data: GroupListDto) {
        this.formData.groupId = data.groupId
        this.formData.groupName = data.groupName
    }

    getLevelId (id: string, data: LevelListDto) {
        this.formData.levelId = data.levelId
        this.formData.levelName = data.levelName
    }

    getDataId (id: string, data: any) {
        this.$set(this.formData, 'merchantsType', data.dataId)
        this.$set(this.formData, 'merchantsTypeName', data.dataName)
        // this.formData.merchantsType = data.dataId
        // this.formData.merchantsTypeName = data.dataName
        console.log(this.formData.merchantsTypeName)

    }
}
